export const summedPercentageValidator = (sections) => {
  try {
    const totalPercentage = sections.reduce((total, section) => section.percentage + total, 0);

    if (totalPercentage < 0 || totalPercentage > 100) {
      const environment = window?.SS_GLOBALS?.environment || 'dev';
      if (environment === 'dev') {
        // oxlint-disable-next-line no-console
        console.error('All Children percentages must sum to a Number between 0 and 100.');
      }
    }
  } catch {
    // ...don't blow up a session for this
  }
};
